import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const CapabilitiesEditorSubmitButtonText = ({
  editorConfigurationKey,
  count = 1
}) => {
  switch (editorConfigurationKey) {
    case 'THREAD_COMMENT':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "composer-ui.send-button.capabilities-editor-submit-button.comment"
      });
    default:
      return !count || count === 1 ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "composer-ui.send-button.capabilities-editor-submit-button.send"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "composer-ui.send-button.capabilities-editor-submit-button.send-count",
        options: {
          count
        }
      });
  }
};
CapabilitiesEditorSubmitButtonText.displayName = 'CapabilitiesEditorSubmitButtonText';
export default CapabilitiesEditorSubmitButtonText;